import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')
    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split('<->')
      const formatMin = parseFloat(min) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      const formatMax = parseFloat(max) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} - ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }
    return value
  }

  return (
    <div class="flex flex-wrap gap-0.5 lg-max:px-margin lg-max:py-1 lg-max:border-b lg-max:border-neutral-medium">
      {[...activeFilters].map((filter) => {
        return (
          <btn class="shrink-0 flex items-center gap-x-0.5 h-[32px] pr-0.625 pl-1 bg-neutral-light text-s whitespace-nowrap link-fade" onClick={() => onRemove(filter)} aria-label={`Remove ${formatFilterValue(filter)} filter`}>
            {formatFilterValue(filter)}
            <div className="flex size-[8px] children:size-full">
              <Icon id="close" />
            </div>
          </btn>
        )
      })}
      <btn class="shrink-0 btn btn-primary btn-text btn-s" onClick={onClear} aria-label="Clear all filters">
        <span class="font-line">Clear all</span>
      </btn>
    </div>
  )
}
